import React from "react";
import { Badge } from "../ui/badge";
import { cn } from "../../lib/utils";

const STATUS_STYLES = {
  // Booking
  pending_approval: "bg-amber-100 text-amber-800",
  approved: "bg-blue-100 text-blue-800",
  confirmed: "bg-green-100 text-green-800",
  in_progress: "bg-indigo-100 text-indigo-800",
  delivered: "bg-purple-100 text-purple-800",
  completed: "bg-emerald-100 text-emerald-800",
  cancelled: "bg-red-100 text-red-800",
  no_show: "bg-red-100 text-red-700",
  // Quote
  requested: "bg-amber-100 text-amber-800",
  sent: "bg-blue-100 text-blue-800",
  viewed: "bg-cyan-100 text-cyan-800",
  accepted: "bg-green-100 text-green-800",
  converted: "bg-emerald-100 text-emerald-800",
  expired: "bg-slate-100 text-slate-600",
  // Payment
  unpaid: "bg-red-100 text-red-700",
  deposit_paid: "bg-amber-100 text-amber-800",
  partially_paid: "bg-yellow-100 text-yellow-800",
  paid: "bg-green-100 text-green-800",
  refunded: "bg-slate-100 text-slate-600",
  refund_partial: "bg-orange-100 text-orange-700",
  // Inventory
  available: "bg-green-100 text-green-800",
  held: "bg-amber-100 text-amber-800",
  booked: "bg-blue-100 text-blue-800",
  cleaning: "bg-cyan-100 text-cyan-700",
  maintenance: "bg-yellow-100 text-yellow-800",
  repair: "bg-orange-100 text-orange-800",
  out_of_service: "bg-red-100 text-red-800",
  // General
  active: "bg-green-100 text-green-800",
  draft: "bg-slate-100 text-slate-600",
  published: "bg-green-100 text-green-800",
  disabled: "bg-red-100 text-red-700",
  pending: "bg-amber-100 text-amber-800",
  rejected: "bg-red-100 text-red-700",
  archived: "bg-slate-100 text-slate-500",
};

export function StatusBadge({ status, className }) {
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-600";
  return (
    <Badge variant="outline" className={cn("border-0 font-medium text-xs", style, className)}>
      {status?.replace(/_/g, " ")}
    </Badge>
  );
}
